import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { protectedResources } from '../auth/auth.config';
import {
  Report,
  ReportDescriptor,
  ReportRequest,
} from '../models/report.model';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private readonly apiEndpoint = protectedResources.apiTodoList.endpoint;

  constructor(private http: HttpClient) {}

  query(reportId: string, body: ReportRequest): Observable<Report> {
    return this.http.post<Report>(
      `${this.apiEndpoint}/report/${reportId}?resolveDevices=true`,
      body,
    );
  }
  queryFlightsBriefReport(body: ReportRequest): Observable<Report> {
    return this.http.post<Report>(
      `${this.apiEndpoint}/report/flights-brief-report?resolveDevices=true`,
      body,
    );
  }
  queryFlightsDurationReport(body: ReportRequest): Observable<Report> {
    return this.http.post<Report>(
      `${this.apiEndpoint}/report/flight-duration-report?resolveDevices=true`,
      body,
    );
  }

  queryServiceDuePerPartReport(body: ReportRequest): Observable<Report> {
    return this.http.post<Report>(
      `${this.apiEndpoint}/report/service-due-per-part-report?resolveDevices=true`,
      { ...body, parameterValues: [] },
    );
  }

  queryServiceDuePerDroneReport(body: ReportRequest): Observable<Report> {
    return this.http.post<Report>(
      `${this.apiEndpoint}/report/service-due-per-drone-report?resolveDevices=true`,
      { ...body, parameterValues: [] },
    );
  }

  queryServiceDoneReport(body: ReportRequest): Observable<Report> {
    return this.http.post<Report>(
      `${this.apiEndpoint}/report/service-done-report?resolveDevices=true`,
      { ...body, parameterValues: [] },
    );
  }

  getAvailableReports(): Observable<ReportDescriptor[]> {
    return this.http.get<ReportDescriptor[]>(`${this.apiEndpoint}/reports`);
  }
}
